'use strict';

import '../../css/components/cookie-consent.scss';
import { cookieConsentElements } from "./elements/cookieConsentElements";

export default class CookieConsent
{
    constructor() {
        this.elements = cookieConsentElements();
        this.allowCookiesDown = this.onAllowCookiesDown.bind(this);
        this.disallowCookiesDown = this.onDisallowCookiesDown.bind(this);
        this.cookieName = 'cookie_consent';
        this.addEventListeners();
        this.init();
    }

    init() {
        const currentCookie = this.getCookie(this.cookieName);
        if (typeof currentCookie === 'undefined') {
            this.showBar();
        }
    }

    addEventListeners() {
        this.elements.allowCookiesButton.addEventListener('click', this.allowCookiesDown);
        this.elements.disallowCookiesButton.addEventListener('click', this.disallowCookiesDown);
    }

    getCookie(cookieName) {
        const name = cookieName + "=";
        const cookieDecoded = decodeURIComponent(document.cookie);
        const cookies = cookieDecoded.split('; ');
        let result;
        cookies.forEach(value => {
            if (value.indexOf(name) === 0) result = value.substring(name.length);
        });
        return result;
    }

    setCookie(cookieName, cookieValue, expirationDays) {
        const date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; path=/";
    }

    showBar() {
        if (this.elements.bar !== null) {
            this.elements.bar.style.display = 'block';
        }
    }

    hideBar() {
        if (this.elements.bar !== null) {
            this.elements.bar.style.display = 'none';
        }
    }

    /**
     * On Allowing cookies, the page needs a reload so the tracking cookies
     * can be initialized in the twig templates.
     */
    onAllowCookiesDown() {
        this.setCookie(this.cookieName, 'allowed', 30);
        this.hideBar();
        window.location.reload();
    }

    /**
     * On disallowing a cookie, no reload is needed. The page already loaded without
     * tracking cookies but the cookie is set so the next page load of this site will
     * also not load the tracking cookies or show the cookie consent banner.
     */
    onDisallowCookiesDown() {
        this.setCookie(this.cookieName, 'disallowed', 30);
        this.hideBar();
    }
}
